
import { defineComponent } from "vue";
import GuardianSubPageHeading from "@/views/guardian/_components/GuardianSubPageHeading/GuardianSubPageHeading.vue";
import SyncWithGWSView from "@/views/_components/SyncWithGWSView/SyncWithGWSView.vue";
import { useRouter } from "vue-router";

export default defineComponent({
  name: "GuardianSync",
  components: { SyncWithGWSView, GuardianSubPageHeading },
  setup() {
    const router = useRouter();

    const onClickBack = () => router.push("/guardian");

    return {
      onClickBack,
    };
  },
});
